var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { EntityBanner } from './entity-banner';
var cls = classNames('link-banner');
export var LinkBannerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  \n  "], ["\n  \n  "])))
});
var BannerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 400;\n  "], ["\n    margin: 0;\n    font-size: 1rem;\n    font-weight: 400;\n  "]))),
  desktop: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 1.1rem;\n  "], ["\n    font-size: 1.1rem;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Banner: styled(EntityBanner)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), BannerStyles),
  Subtitle: styled.h2.attrs(cls.attr('subtitle'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles)
};
export var LinkBanner = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    aspectRatio = props.aspectRatio;
  var transformEntity = function (link) {
    var targetEntity = (link === null || link === void 0 ? void 0 : link.page) || (link === null || link === void 0 ? void 0 : link.event) || link;
    var path = link.url || (targetEntity === null || targetEntity === void 0 ? void 0 : targetEntity.path) || undefined;
    var transformedEntity = __assign(__assign({}, targetEntity), {
      typeLabel: entity === null || entity === void 0 ? void 0 : entity.typeLabel,
      title: link.bannerTitle || (targetEntity === null || targetEntity === void 0 ? void 0 : targetEntity.title),
      path: path
    });
    return transformedEntity;
  };
  var transformedEntity = transformEntity(entity);
  var hasBannerTitles = !!(transformedEntity === null || transformedEntity === void 0 ? void 0 : transformedEntity.bannerSubtitle) || !!(transformedEntity === null || transformedEntity === void 0 ? void 0 : transformedEntity.subtitle);
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Banner, {
    customAspectRatio: aspectRatio,
    entity: transformedEntity,
    showTitles: true,
    content: hasBannerTitles && React.createElement(React.Fragment, null, React.createElement(My.Subtitle, null, (transformedEntity === null || transformedEntity === void 0 ? void 0 : transformedEntity.bannerSubtitle) || (transformedEntity === null || transformedEntity === void 0 ? void 0 : transformedEntity.subtitle)))
  }), children);
};
LinkBanner.defaultProps = LinkBannerDefaultProps;
LinkBanner.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;